import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DeleteIcon from '@mui/icons-material/Delete'

/**
 * A tooltip needs a live element to listen on, and a disabled button fires no events — hence the
 * span. Without it MUI warns and the tooltip silently stops working once the button greys out.
 */
const Action = ({ title, children, ...props }) => (
  <Tooltip title={title}>
    <span>
      <IconButton size='small' {...props}>
        {children}
      </IconButton>
    </span>
  </Tooltip>
)

/**
 * Move-and-remove, the same set on a group as on a prize. `onClone` is prize-only, so optional, and
 * `iconSize` lets a prize sit a size below the group it belongs to.
 */
const RowActions = ({
  onUp,
  onDown,
  isFirst,
  isLast,
  onClone,
  onRemove,
  canRemove,
  removeTitle,
  iconSize = 'medium',
}) => (
  <Box display='flex' alignItems='center' gap={1}>
    <Action title='Move up' onClick={onUp} disabled={isFirst}>
      <ArrowUpwardIcon fontSize={iconSize} />
    </Action>
    <Action title='Move down' onClick={onDown} disabled={isLast}>
      <ArrowDownwardIcon fontSize={iconSize} />
    </Action>
    {onClone && (
      <Action title='Duplicate' onClick={onClone}>
        <ContentCopyIcon fontSize={iconSize} />
      </Action>
    )}
    <Action title={removeTitle} color='error' onClick={onRemove} disabled={!canRemove}>
      <DeleteIcon fontSize={iconSize} />
    </Action>
  </Box>
)

export default RowActions
